export const employeeFormValidation = (formData) => {
    try {
        const errorObj = {};
        const company_id = formData.company_id?.trim();
        if (!company_id) {
            errorObj.company_id = "Please enter company"
        }

        const name = formData.name?.trim();
        if (!name) {
            errorObj.name = "Please enter name"
        }

        const country_code = formData.country_code?.trim();
        if (!country_code) {
            errorObj.country_code = "Please select country code"
        }

        const phone = formData.phone?.trim();
        if (!phone) {
            errorObj.phone = "Please enter phone number"
        }

        if (Object.keys(errorObj)?.length) {
            return { errorMessage: errorObj }
        }

        return {
            data: { company_id, name, country_code, phone_number: phone }
        }
    } catch (error) { }
}

export const sendMessageValidation = (formData) => {
    try {
        const errorObj = {};
        const id = formData.id?.trim();
        if (!id) {
            errorObj.id = "Please enter messageId"
        }

        const employeeId = formData.employee_id?.trim();
        if (!employeeId) {
            errorObj.employeeId = "Please enter employee"
        }

        const content = formData.message?.trim();
        if (!content) {
            errorObj.content = "Please enter message"
        }

        const phoneNumber = formData.phone_number?.trim();
        if (!phoneNumber) {
            errorObj.phoneNumber = "Please enter phonenumber"
        }

        if (Object.keys(errorObj)?.length) {
            return { errorMessage: errorObj }
        }

        return {
            data: { id, employeeId, content, phoneNumber }
        }

    } catch (error) { }
}